module.exports = __webpack_public_path__ + "static/img/22.b4069a6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hhmnq/22.jpg
// module id = WqoT
// module chunks = 1